<template>
  <FilterBlock :showFilter="showFilter" :title="$t('common_filterBy.localization_value.value')" @close="closeFilter"
               @changeFilter="changeFilter">
    <template slot="body">

      <div class="table-filter__item"
           v-if="isAdmin"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <span class="admin-edit" @click="editTranslate(['common_user'])"></span>
        <SearchSelect
            :options="options"
            :label="$t('common_user.localization_value.value')"
            :optionsLabel="'email.contacts[0]'"
            :functionSearch="functionSearchUserFilter"
            @change="changeUsersFilter"
            :selected="userName"
            :typeSelect="'users'"
            :userEmail="true"
        />
      </div>

      <div class="table-filter__item"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <span class="admin-edit" @click="editTranslate(['fba_orderId'])"></span>
        <DefaultInput
            :label="$t('fba_orderId.localization_value.value')"
            :type="'text'"
            v-model="id"
        />
      </div>

      <div class="table-filter__item"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <span class="admin-edit" @click="editTranslate(['fba_created'])"></span>
        <DatePickerDefault
            :label="$t('fba_created.localization_value.value')"
            v-model="date"
        >
          <template slot="body">
            <date-picker
                v-model="date"
                ref="datePicker"
                valueType="format"
                :lang="$store.getters.getDatePickerTranslations[$store.getters.GET_LANG]"
                :format="'MM/DD/YY'"
                :placeholder="'mm/dd/yy'"
                range
            ></date-picker>
          </template>
        </DatePickerDefault>
      </div>

      <div class="table-filter__item"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <span class="admin-edit" @click="editTranslate(['fba_shipped'])"></span>
        <DatePickerDefault
            :label="$t('fba_shipped.localization_value.value')"
            v-model="shippedDate"
        >
          <template slot="body">
            <date-picker
                v-model="shippedDate"
                ref="datePicker"
                valueType="format"
                :lang="$store.getters.getDatePickerTranslations[$store.getters.GET_LANG]"
                :format="'MM/DD/YY'"
                :placeholder="'mm/dd/yy'"
                range
            ></date-picker>
          </template>
        </DatePickerDefault>
      </div>

      <div class="table-filter__item"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <span class="admin-edit" @click="editTranslate(['fba_trackingNumber'])"></span>
        <DefaultInput
            :label="$t('fba_trackingNumber.localization_value.value')"
            :type="'text'"
            v-model="trackingNumber"
        />
      </div>

      <div class="table-filter__item"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fba_orderStatus'])"></div>
        <DefaultSelect
            :label="$t('fba_orderStatus.localization_value.value')"
            :options="statusList"
            :optionsLabel="'name'"
            :selected="getStatusSelected()"
            @change="changeStatus"
        />
      </div>

      <div class="table-filter__item"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fba_orderWarehouse'])"></div>
        <DefaultSelect
            :label="$t('fba_orderWarehouse.localization_value.value')"
            :options="warehouseOptions"
            :optionsLabel="'name'"
            :selected="getWarehouseId"
            @change="changeWarehouseId"
        />
      </div>

    </template>
    <template slot="footer">
      <MainButton @click.native="resetFilter" :value="$t('common_resetFilters.localization_value.value')"
                  class="secondary wfc"/>
      <MainButton @click.native="changeFilter" :value="$t('common_applyFilters.localization_value.value')" class="wfc"/>
    </template>
  </FilterBlock>
</template>

<script>
import FilterBlock from "../../../../../../coreComponents/FilterBlock/FilterBlock";
import MainButton from "../../../../../../UI/buttons/MainButton/MainButton";
import DefaultInput from "../../../../../../UI/inputs/DefaultInput/DefaultInput";
import DatePickerDefault from "../../../../../../UI/inputs/DatePickerDefault/DatePickerDefault";
import DatePicker from 'vue2-datepicker'
import {filterFunc} from "../../../../../../../mixins/filterFuncMixin/filterFunc";
import SearchSelect from "../../../../../../UI/selectiones/SearchSelect/SearchSelect";
import {usersFunc} from "../../../../../../../mixins/usersMixins/usersFunc";
import {FBA_ORDER_STATUS} from "../../../../../../../staticData/staticVariables";
import DefaultSelect from "../../../../../../UI/selectiones/DefaultSelect/DefaultSelect";

export default {
  name: "OrdersFBAFilter",
  components: {
    FilterBlock,
    MainButton,
    DatePickerDefault,
    DatePicker,
    DefaultInput,
    DefaultSelect,
    SearchSelect,
  },

  mixins: [filterFunc, usersFunc],

  props: {
    showFilter: Boolean,
    filterGetParams: Object,
  },

  data() {
    return {
      date: this.filterGetParams.date ? this.generateFilterDate(this.filterGetParams.date, 'MM/DD/YY') : '',
      shippedDate: this.filterGetParams.shippedDate ? this.generateFilterDate(this.filterGetParams.shippedDate, 'MM/DD/YY') : '',
      userName: this.filterGetParams.userName ? this.filterGetParams.userName : '',
      userId: this.filterGetParams.userId ? this.filterGetParams.userId : '',
      id: this.filterGetParams.id ? this.filterGetParams.id : '',
      trackingNumber: this.filterGetParams.trackingNumber ? this.filterGetParams.trackingNumber : '',
      status: this.filterGetParams.status ? this.filterGetParams.status : '',
      warehouseId: this.filterGetParams.warehouseId ? this.filterGetParams.warehouseId : '',

      filterCounts: [
        'date',
        'shippedDate',
        'id',
        'trackingNumber',
        'status',
        'warehouseId',

        'userName',
        'userId',
      ],

      options: [],
      warehouseOptions: [],
      statusList: FBA_ORDER_STATUS,
    }
  },

  watch: {
    filterGetParams(newVal) {
      this.date = newVal.date ? this.generateFilterDate(newVal.date, 'MM/DD/YY') : ''
      this.shippedDate = newVal.shippedDate ? this.generateFilterDate(newVal.shippedDate, 'MM/DD/YY') : ''
      this.id = newVal.id ? newVal.id : ''
      this.trackingNumber = newVal.trackingNumber ? newVal.trackingNumber : ''
      this.status = newVal.status ? newVal.status : ''
      this.warehouseId = newVal.warehouseId ? newVal.warehouseId : ''

      this.userName = newVal.userName ? newVal.userName : ''
      this.userId = newVal.userId ? newVal.userId : ''
    },
  },

  computed: {
    getWarehouseId(){
      if(this.warehouseId === '') return ''
      return this._.find(this.warehouseOptions, {id: Number(this.warehouseId)})
    },
  },

  mounted() {
    this.$store.dispatch('fetchWarehouseStorage').then(response => {
      this.warehouseOptions = this.getRespPaginateData(response)
    })
  },

  methods: {
    closeFilter() {
      this.$emit('close')
    },

    resetFilter() {
      let data = this.resetFilterParams(this, this.filterCounts)

      this.$emit('changeFilter', data)
    },

    changeFilter() {
      let data = this.changeFilterParams(this, this.filterCounts)
      data.date = this.changeDateParams(this, 'date')
      data.shippedDate = this.changeDateParams(this, 'shippedDate')

      this.$emit('changeFilter', data)
    },

    getStatusSelected(){
      if(this.status === '') return ''
      return this._.find(this.statusList, {value: this.status})
    },

    changeStatus(val) {
      this.status = val.value
    },

    changeWarehouseId(val) {
      this.warehouseId = val.id
    },

  },
}
</script>

<style scoped>

</style>
